import React, {Component} from 'react'
import { Card, SlideshowMobile } from './..'
import { SuggestTemplateStyle } from './../../styles'
export default class SuggestTemplate extends Component {
  state = {

  }
  
  render() {
    const { picture, picturePosition, title, items } = this.props
    return (
      <div className={`product-template--suggest product-template ${SuggestTemplateStyle(picture)}`}>
        <div className="template-scroll">
          {
            picture && <div className='template-left'></div>
          }
          <div className={`template-right ${!picture ? 'full' : ''} template-content`}>
            <div className='flex'>
              <h2 className="subtitle">{ title }</h2>
              <div className="suggest-container">
                <div className="flex flex-wrap">
                    {
                      items.map((product, index) => (
                        <Card 
                          title={product.name} 
                          description={product.description} 
                          slug={product.url} 
                          cover={product.picture} 
                          pdfs={product.pdfs} 
                          is_bookmark={product.is_bookmark}
                          slug_bookmark={product.slug_bookmark}
                          key={index} />
                      ))
                    }
                </div>
              </div>
            </div>
          
          </div>
        </div>
      </div>
    )
  }
}


// WEBPACK FOOTER //
// ./src/components/SliderTemplates/SuggestTemplate.js